import React from 'react';

const WhyChooseUs = () => {
  return (
    <section className="why-choose-us-two">
      <div className="bg-layer"></div>
      <div className="auto-container">
        <div className="row">
          {/* Content Column */}
          <div className="content-column col-lg-6 col-md-12">
            <div className="inner-column wow fadeInRight">
              <div className="sec-title">
                <i className="sub-title">Our benefits</i>
                <h2>Firmamızı Seçmeniz İçin Bazı Nedenler</h2>
                <div className="text">
                  Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem is simply free text quis bibendum. There are many variations of passages of available.
                </div>
              </div>
              <div className="info-box">
                <div className="inner">
                  <figure className="thumb">
                    <img src="/assets/images/resource/avatar-1.jpg" alt="Aleesha Brown" />
                  </figure>
                  <h5 className="title">Aleesha Brown</h5>
                  <span className="sub-title">CEO &amp; CO Founder</span>
                </div>
                <a className="theme-btn btn-style-one" href="page-about.html">
                  <span className="btn-title">Şimdi Keşfet</span>
                </a>
              </div>
            </div>
          </div>

          {/* Features Column */}
          <div className="features-column col-lg-6 col-md-12 col-sm-12">
            <div className="inner-column wow fadeInLeft">
              <div className="row">
                {[
                  { title: 'Doğrudan Mülakatlar', icon: 'fa-users' },
                  { title: 'Ekonomik', icon: 'fa-funnel-dollar' },
                  { title: 'Müşterilerin Güvendiği', icon: 'fa-handshake' },
                  { title: '7/24 Destek', icon: 'fa-headset' },
                ].map((item, index) => (
                  <div className="feature-block-two col-lg-6 col-md-6 col-sm-12" key={index}>
                    <div className="inner-box">
                      <h5>{item.title}</h5>
                      <div className="text">Fusce pretium sem is the eget mattis</div>
                      <span className={`icon fa ${item.icon}`}></span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;